/**
 * A fenced block is closed by the first run of backticks at least as long as the opening one,
 * so content that itself contains backticks needs a longer fence.
 */
export const getFence = (content?: string): string => {
	const runs: string[] = content?.match(/`+/g) ?? [];
	const longest = runs.reduce((max, run) => Math.max(max, run.length), 0);
	return "`".repeat(Math.max(3, longest + 1));
};
